import { render, staticRenderFns } from "./kindeditor.vue?vue&type=template&id=b7481d38&"
import script from "./kindeditor.vue?vue&type=script&lang=js&"
export * from "./kindeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports